import React from 'react';
import { ButtonClick } from '../types';
import styled from 'styled-components';
import BaseButton from './BaseButton';
import ButtonLoadingSpinner from './ButtonLoadingSpinner';
import Link from './Link';

interface Props {
    //stupid typescript
    onClick?: (e: ButtonClick | HTMLAnchorElement | any) => any;
    isLoading?: boolean | undefined;
    children: string;
    primary?: boolean;
    disabled?: boolean;
    to?: string;
    type?: 'button' | 'submit';
}
export default ({
    onClick = () => {},
    isLoading = undefined,
    children,
    type = 'submit',
    disabled = false,
    to,
}: Props): JSX.Element => {
    const Element: any = Boolean(to) ? Link : BaseButton;
    return (
        <Element onClick={onClick} type={type} disabled={disabled} to="">
            {/* if isLoading prop is not passed, the spinner will not be used  */}
            <ButtonLoadingSpinner isLoading={isLoading !== undefined ? isLoading : false} />
            <ButtonText isLoading={isLoading !== undefined ? isLoading : false}>
                {children}
            </ButtonText>
        </Element>
    );
};

const ButtonText = styled.p<{ isLoading: boolean }>`
    font-weight: bold;
    transition: opacity 200ms;
    transition-delay: ${({ isLoading }: { isLoading: boolean }) => (isLoading ? '0ms' : '200ms')};
    width: 100%;
    opacity: ${({ isLoading }: { isLoading: boolean }) => (isLoading ? 0 : 1)};
`;
